// src/services/blogService.js
import axios from "axios";

const API_URL = "/api/blogs";

const getHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    ...(token && { Auth: token }),
  };
};

const handleRequest = async (url, options = {}) => {
  try {
    const response = await axios({
      url,
      method: options.method || "GET",
      headers: getHeaders(),
      data: options.data,
    });

    const data = response.data;

    // If backend already wraps with success/data/message, pass it through
    if (data && typeof data.success !== "undefined") {
      return data;
    }

    return {
      success: true,
      data,
      message: data?.message || "",
    };
  } catch (error) {
    const status = error.response?.status;
    const data = error.response?.data;
    let message = data?.message;

    if (!message) {
      if (status === 401 || status === 403) {
        message = "You are not authorized to perform this action.";
      } else if (status >= 500) {
        message = "Server error occurred. Please try again later.";
      } else if (status) {
        message = "Request failed. Please try again.";
      } else {
        message = "Network error. Please check your internet connection.";
      }
    }

    return {
      success: false,
      data: null,
      message,
    };
  }
};

export const blogService = {
  // Fetch all blogs
  getBlogs: async (page = 1, limit = 10) => {
    try {
      const url = `${API_URL}?page=${page}&limit=${limit}`;
      const result = await handleRequest(url, {
        method: "GET",
      });
      return result;
    } catch (error) {
      throw error;
    }
  },

  // Fetch a single blog by its slug
  getBlogBySlug: async (slug) => {
    try {
      const result = await handleRequest(`${API_URL}/${slug}`, {
        method: "GET",
      });
      return result;
    } catch (error) {
      throw error;
    }
  },

  // Create a new blog
  createBlog: async (data) => {
    try {
      const result = await handleRequest(API_URL, {
        method: "POST",
        data,
      });
      return result;
    } catch (error) {
      throw error;
    }
  },

  // Update an existing blog passing ONLY changed fields
  updateBlog: async (id, data) => {
    try {
      const result = await handleRequest(`${API_URL}/${id}`, {
        method: "PUT",
        data,
      });
      return result;
    } catch (error) {
      throw error;
    }
  },

  // Delete an existing blog
  deleteBlog: async (id) => {
    try {
      const result = await handleRequest(`${API_URL}/${id}`, {
        method: "DELETE",
      });
      return result;
    } catch (error) {
      throw error;
    }
  },
};
